import React from 'react'
import { InputContainer } from '../../../../../../common/components/form/form.module'
import { InputLabelContainer } from '../../../../../../common/components/form/label/containers/input-label.container'
import _ from 'lodash'

export default function SettlementItemBasicInfoComponent({
  handleInnerFormChange,
  selectedSettlementItem,
  // selectedSettlementItem,
  onClose,
  handleFormSubmit
}: any) {
  console.log('selectedSettlementItem', selectedSettlementItem)
  // console.log('selectedSettlementItem', selectedSettlementItem)
  return (
    <>
      <div className="flex justify-center items-center w-[600px]">
        <div className="w-full max-w-lg p-2 bg-white shadow-md rounded-md">
          <h1 className="text-xl font-bold mb-4 text-center">{  selectedSettlementItem?.Id ? "Edit Settlement Item" : "Add New Settlement Item"}</h1>
          <div className="flex flex-col gap-4">          
          <InputContainer
                    label="Participant"
                    name="ParticipantId"
                    onValueChange={(event: any) => {
                      handleInnerFormChange({
                        value: event.target.value,
                        path: 'selectedSettlementItem.ParticipantId',
                      })
                    }}
                    type="text"
                    value={selectedSettlementItem.ParticipantId}
                  />

                  <InputContainer
                    label="Status"
                    name="SettlementItemStatusId"
                    onValueChange={(event: any) => {
                      handleInnerFormChange({
                        value: event.target.value,
                        path: 'selectedSettlementItem.SettlementItemStatusId',

                      })
                    }}
                    type="text"
                    value={selectedSettlementItem?.SettlementItemStatusId}
                  />                                
                  <InputContainer
                    label="Recerence No"
                    name="ReferenceNo"
                    onValueChange={(event: any) => {
                      handleInnerFormChange({
                        value: event.target.value,
                        path: 'selectedSettlementItem.ReferenceNo',

                      })
                    }}
                    type="text"
                    value={selectedSettlementItem?.ReferenceNo}
                  />      
                  <InputContainer
                    label="Settlement For"
                    name="SettlementFor"
                    onValueChange={(event: any) => {
                      handleInnerFormChange({
                        value: event.target.value,
                        path: 'selectedParticipant.SettlementFor',

                      })
                    }}
                    type="text"
                    value={selectedSettlementItem?.SettlementFor}
                  />                            
                  <InputContainer
                    label="Settled Amount"
                    name="SettledAmount"
                    onValueChange={(event: any) => {
                      handleInnerFormChange({
                        value: event.target.value,
                        path: 'selectedSettlementItem.SettledAmount?.value',

                      })
                    }}
                    type="text"
                    value={selectedSettlementItem?.SettledAmount?.value}
                  />                                
                  <InputContainer
                    label="Amount"
                    name="Amount"
                    onValueChange={(event: any) => {
                      handleInnerFormChange({
                        value: event.target.value,
                        path: 'selectedSettlementItem.Amount?.value',

                      })
                    }}
                    type="text"
                    value={selectedSettlementItem?.Amount?.value}
                  />                                
          </div>
          <div className="flex justify-end mt-6">
            <button
              onClick={onClose}
              type="button"
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
            >
              Close
            </button>
            <button
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
              onClick={handleFormSubmit}
              type="submit"
            >
              Save
            </button>
          </div>
        </div>
      </div>

    </>
  )
}